<template>
  <span v-if="summaryParams?.column?.field?.addonBefore">
    {{ summaryParams.column.field.addonBefore }}
  </span>
  {{ value }}
  <span v-if="summaryParams?.column?.field?.addonAfter">
    {{ summaryParams.column.field.addonAfter }}
  </span>
</template>
<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps({
  summaryParams: {
    type: Object,
    required: true,
  },
  tableDataSource: {
    type: Array,
    required: true,
  },
});
const value = computed(() => {
  let totla: any = 0;
  for (const item of props.tableDataSource) {
    let itemValue = item[props.summaryParams.column.dataIndex];
    if (props.summaryParams.column.field.type === 'number') {
      itemValue = getValue(props.summaryParams.column.field, itemValue);
    } else {
      itemValue = parseFloat(itemValue);
    }
    if (isNaN(itemValue) || itemValue == null) {
      itemValue = 0;
    }
    totla = add(totla, itemValue);
  }
  if (props.summaryParams.column.field.type === 'number') {
    const precision = props.summaryParams.column.field.precision;
    if (precision) {
      totla = totla.toFixed(precision);
    }
  }
  return totla;
});
function replaceEnd(str, target, replacement) {
  if (str.endsWith(target)) {
    return str.slice(0, -target.length) + replacement;
  }
  return str;
}
function replaceStart(str, target, replacement) {
  if (str.startsWith(target)) {
    return replacement + str.slice(target.length);
  }
  return str;
}
function add(a, b) {
  const precision = Math.max(
    (a.toString().split('.')[1] || '').length,
    (b.toString().split('.')[1] || '').length,
  );
  return parseFloat((a + b).toFixed(precision));
}
const getValue = (field: any, value: any) => {
  if (typeof value === 'string') {
    if (field.addonAfter) {
      value = replaceEnd(value, field.addonAfter, '');
    }
    if (field.addonBefore) {
      value = replaceStart(value, field.addonBefore, '');
    }
    value = parseFloat(value);
  }
  return value;
};
</script>
<style lang="less" scoped></style>
